export default ({ value, isCheckStringNull, isCheckNumberNull }) => {
  return value === undefined || value === null || (isCheckStringNull && value === '') || (isCheckNumberNull && value === 0);
};
